import { render } from "./IndexTables.vue?vue&type=template&id=6d5f5f2a&scoped=true"
import script from "./IndexTables.vue?vue&type=script&lang=ts"
export * from "./IndexTables.vue?vue&type=script&lang=ts"

import "./IndexTables.vue?vue&type=style&index=0&id=6d5f5f2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d5f5f2a"

export default script